var _defs, _path, _rect, _path2, _path3, _rect2, _path4, _rect3, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureBatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a8",
    x1: 7.05,
    y1: 8.98,
    x2: 7.05,
    y2: 0.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b8",
    x1: 7.05,
    y1: 3.78,
    x2: 7.05,
    y2: 2.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#194f9b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#194f9c",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#18519e",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1654a2",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1457a7",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#115cae",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0d62b6",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#096ac0",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0472cb",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.78 8.89L17.65 7c.15-.16.1-.29-.13-.29h-.93a.23.23 0 01-.23-.24c0-1.18-.3-4.47-4.8-4.58a.23.23 0 00-.24.23v1.14a.23.23 0 00.25.23 2.75 2.75 0 013.33 3 .23.23 0 01-.23.24h-.87c-.23 0-.28.13-.13.3l1.74 1.9a.24.24 0 00.37-.04z",
    fill: "#949494"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.82,
    y: 0.34,
    width: 12.46,
    height: 8.64,
    rx: 0.57,
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38.34h11.49a.41.41 0 01.41.41V2.4H.82V.91a.57.57 0 01.56-.57z",
    fill: "#83b9f9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M.82 2.4h12.46v1.38H.82z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.9,
    y: 10.95,
    width: 7.92,
    height: 5.49,
    rx: 0.36,
    fill: "#005ba1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61 3.19h8.87a.19.19 0 01.19.18v.93a.19.19 0 01-.19.17H2.61a.18.18 0 01-.19-.17v-.93a.18.18 0 01.19-.18zM2.61 5h8.88a.17.17 0 01.18.17v.93a.18.18 0 01-.18.18H2.61a.18.18 0 01-.18-.18v-.89A.17.17 0 012.61 5zM2.61 6.89h8.88a.18.18 0 01.18.18V8a.18.18 0 01-.18.17H2.61A.18.18 0 012.43 8v-.93a.18.18 0 01.18-.18z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.59,
    y: 9.77,
    width: 7.92,
    height: 5.49,
    rx: 0.36,
    fill: "#0078d4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.77h7.3a.26.26 0 01.26.26v1H8.59v-.95A.36.36 0 019 9.77z",
    fill: "#83b9f9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73 11.59h5.64a.12.12 0 01.12.11v.59a.12.12 0 01-.12.11H9.73a.11.11 0 01-.12-.11v-.59a.11.11 0 01.12-.11zM9.73 12.76h5.64a.11.11 0 01.12.11v.59a.11.11 0 01-.12.11H9.73a.12.12 0 01-.12-.11v-.59a.12.12 0 01.12-.11zM9.73 13.94h5.64a.11.11 0 01.12.11v.59a.11.11 0 01-.12.11H9.73a.12.12 0 01-.12-.11v-.59a.12.12 0 01.12-.11z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureBatch);
export default __webpack_public_path__ + "static/media/azure-batch.840247135444e306463edf7df2352277.svg";
export { ForwardRef as ReactComponent };